import React, { Component } from "react";

import { Form, Button, Input, Card, message } from "antd";
import { EnvioForm } from './components/envio_form'


import 'antd/dist/antd.css';

export default class Envio extends React.Component {
    render() {
        return (
            <React.Fragment>
                <EnvioForm />

            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Sms/Envio/index.js